/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-22 14:55:26
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-05-16 08:50:08
 */
export default [
  {
    path: '/hbsgsl_old',
    name: 'HbsgslOld',
    component: () => import(/*webpackChunkName:'HbsgslOld'*/ '@/views/hbsgsl/index'),
    meta: { title: '湖北省工商联' },
  },
  {
    path: '/hbsgsl',
    name: 'Hbsgsl',
    component: () => import(/*webpackChunkName:'Hbsgsl'*/ '@/views/hbsgsl/new'),
    meta: { title: '湖北省工商联' },
  },
]
